module.exports = __webpack_public_path__ + "img/car.753c3cfd.png";